import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskPlaybooksEditRoute: InvariantJiraRoute = {
	name: 'project-settings-playbooks-edit',
	path: '/jira/servicedesk/projects/:projectKey/settings/playbooks/:playbookId',
	exact: true,
};
